export const REACTION_TIMEOUT = typeof jest === 'undefined' ? 100 : 0
export const SUMMARY_REACTIONS_TIMEOUT = typeof jest === 'undefined' ? 500 : 0
